import { useState, useEffect } from "react";
import { useNotificationStore } from "./NotificationStore";
import OutageNotificationDialog from './OutageNotificationDialog';
import userProfileStore,{useUserLastLoggedInStore} from '../core/UserProfileStore';
import moment from 'moment';

export const NotificationContainer = () => {
  const notifications = useNotificationStore((state: any) => state.notifications);
  const [notifyMessage, showNotification] = useState(false);
  const { loggedInDate  } = useUserLastLoggedInStore();
  const { oktaUserProfile  } = userProfileStore();

  useEffect(() => {
    let lastLoggedInDate = moment.utc(loggedInDate,'dddd, MMMM DD, YYYY at h:mm:ss A Z');
    let oktaLoggedInDate = moment.utc(oktaUserProfile.lastLogin,'YYYY-MM-DDThh:mm:ss A Z');
    const nav = performance.getEntriesByType("navigation")[0] as PerformanceNavigationTiming;
    if (notifications && notifications.length > 0 && 
        notifications[0].type === 'outage' &&
        notifications[0].read === false &&
        !lastLoggedInDate.isSame(oktaLoggedInDate) &&
        nav?.type === 'navigate'
      ) {
          showNotification(true);
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[notifications]);

  return (
    <>
        <OutageNotificationDialog
        isOpen={notifyMessage}
        onClose={() => showNotification(false)} />
    </>
  );
};
